import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { useState } from 'react';
import ResultListContainer from '../../../containers/employeemng/result/ResultListContainer';
import ResultFormContainer from '../../../containers/employeemng/result/ResultFormContainer';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`result-tabpanel-${index}`}
      aria-labelledby={`result-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `result-tab-${index}`,
    'aria-controls': `result-tabpanel-${index}`,
  };
}

const ResultTabs = ({ employee, edit }) => {
  const [selectTab, setSelectTab] = useState(0);
  const handleChange = (event, newTab) => {
    setSelectTab(newTab);
  };
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectTab}
            onChange={handleChange}
            aria-label="result tabs"
          >
            <Tab label="성과관리" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <TabPanel value={selectTab} index={0}>
          {edit && <ResultFormContainer employee={employee} />}
          <ResultListContainer employee={employee} />
        </TabPanel>

      </Box>
    </div>
  );
};

export default ResultTabs;
